<img src="assets/img/PDI Logo-RGB-Two Color-with Tag-Digital.png" alt="PDI Technologies" />

<h4>Oops!</h4>

<div>
    <p>{{errMsg}}</p>
</div>

<p><a href="/welcome">Home</a></p>